/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
import type { TokenLogListDto } from './TokenLogListDto';
import {
    TokenLogListDtoFromJSON,
    TokenLogListDtoFromJSONTyped,
    TokenLogListDtoToJSON,
} from './TokenLogListDto';

/**
 * 
 * @export
 * @interface TokenLogListDtoOffsetPaginationResult
 */
export interface TokenLogListDtoOffsetPaginationResult {
    /**
     * 
     * @type {Array<TokenLogListDto>}
     * @memberof TokenLogListDtoOffsetPaginationResult
     */
    data?: Array<TokenLogListDto> | null;
    /**
     * 
     * @type {number}
     * @memberof TokenLogListDtoOffsetPaginationResult
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof TokenLogListDtoOffsetPaginationResult
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof TokenLogListDtoOffsetPaginationResult
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof TokenLogListDtoOffsetPaginationResult
     */
    pageCount?: number;
}

/**
 * Check if a given object implements the TokenLogListDtoOffsetPaginationResult interface.
 */
export function instanceOfTokenLogListDtoOffsetPaginationResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TokenLogListDtoOffsetPaginationResultFromJSON(json: any): TokenLogListDtoOffsetPaginationResult {
    return TokenLogListDtoOffsetPaginationResultFromJSONTyped(json, false);
}

export function TokenLogListDtoOffsetPaginationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenLogListDtoOffsetPaginationResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(TokenLogListDtoFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageCount': !exists(json, 'pageCount') ? undefined : json['pageCount'],
    };
}

export function TokenLogListDtoOffsetPaginationResultToJSON(value?: TokenLogListDtoOffsetPaginationResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(TokenLogListDtoToJSON)),
        'totalCount': value.totalCount,
        'pageSize': value.pageSize,
        'page': value.page,
        'pageCount': value.pageCount,
    };
}

